/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

module.exports.onClientEntry = () => {
  // Only prevent zoom on the MAP page
  // Check if we're on the map page
  const isMapPage = () => document.body.getAttribute('data-page') === 'map';

  // Prevent double-tap zoom (only on map page)
  let lastTouchEnd = 0;
  document.addEventListener('touchend', (event) => {
    if (!isMapPage()) return; // Allow double-tap on other pages

    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, { passive: false });

  // Prevent pinch zoom gesture (only on map page)
  document.addEventListener('gesturestart', (event) => {
    if (!isMapPage()) return; // Allow gestures on other pages
    event.preventDefault();
  }, { passive: false });

  document.addEventListener('gesturechange', (event) => {
    if (!isMapPage()) return; // Allow gestures on other pages
    event.preventDefault();
  }, { passive: false });

  document.addEventListener('gestureend', (event) => {
    if (!isMapPage()) return; // Allow gestures on other pages
    event.preventDefault();
  }, { passive: false });

  // Prevent multi-touch zoom (only on map page, and only when event.scale exists and is not 1)
  document.addEventListener('touchmove', (event) => {
    if (!isMapPage()) return; // Allow all touch moves on other pages

    // Only prevent if event.scale exists AND is not 1 (actual pinch gesture)
    // This fixes Android scrolling by not blocking when event.scale is undefined
    if (event.scale !== undefined && event.scale !== 1) {
      event.preventDefault();
    }
  }, { passive: false });

  // Prevent wheel zoom (Ctrl/Cmd + scroll)
  document.addEventListener('wheel', (event) => {
    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
    }
  }, { passive: false });

  // Prevent keyboard zoom (Ctrl/Cmd + plus/minus)
  document.addEventListener('keydown', (event) => {
    if ((event.ctrlKey || event.metaKey) &&
        (event.key === '+' || event.key === '-' || event.key === '=')) {
      event.preventDefault();
    }
  }, { passive: false });
};

module.exports.onRouteUpdate = ({ location, prevLocation }) => {
  const event = new CustomEvent(
    'route-change',
    { detail: { location, prevLocation } }
  );
  window.dispatchEvent(event);
};
